<template>
  <v-footer
    height="auto" >
    <v-card
      v-bind="style.section"
      flat
      tile
      class="indigo lighten-1 white--text text-xs-center"
      style="width:100%" >
      <v-card-text right>
        <v-layout
          v-for="(action, i) in actions"
          :key="`action_${i}`"
          class="xs-12 white--text text-xs-right footer-link"
          row >
          <v-flex 
            right
            class="mr-3">
            <span 
              class="pt-2 text-xs-right cursor"
              @click="processAction(action)">
              <template v-if="action.text">
                {{ action.text }}
              </template>
              <template v-else>
                {{ action.to }}
              </template>
            </span>
            <v-icon 
              class="ml-2 my-1 cursor"
              small
              size="24px"
              @click="processAction(action)">
              {{ action.icon }}
            </v-icon>
          </v-flex>
        </v-layout>
      </v-card-text>
      <!--
      <v-card-text class="white--text pt-0">
        bla bla bla
      </v-card-text>
      -->
      <v-divider/>

      <v-card-text 
        class="white--text"
        @click="navigateTo({name: 'Home'})">
        &copy;{{ year }} — <strong>{{ $t('site.name') }}</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
import { mapState } from 'vuex'
import DateHelper from '@/lib/DateHelper'
export default {
  name: 'ContentFooter',
  data() {
    return {
      actions: [
        {
          icon: 'fas fa-home',
          text: 'Home',
          action: 'navigate',
          to: 'Home',
        },
        {
          icon: 'fab fa-leanpub',
          action: 'navigate',
          text: this.$t('menu.tutorial'),
          to: 'Tutorial',
        },
        {
          icon: 'fas fa-envelope',
          action: 'mail',
          to: this.$t('site.email'),
        },
        {
          icon: 'fab fa-facebook',
          action: 'open',
          text: 'Facebook',
          to: this.$t('site.facebook.url'),
        },
        {
          icon: 'fab fa-twitter',
          action: 'open',
          text: 'Twitter',
          to: this.$t('site.twitter.url'),
        },
        {
          icon: 'fab fa-discord',
          action: 'open',
          text: 'Discord',
          to: this.$t('site.discord.url'),
        },
      ],
    }
  },
  computed: {
    ...mapState({
      style: state => state.style.style,
    }),
    year() {
      return DateHelper.getYearNumber()
    },
  },
  methods: {
    processAction(item) {
      switch (item.action) {
        case 'navigate':
          this.navigateTo({ name: item.to })
          break
        case 'open':
          this.navigateOpen(item.to)
          break
        case 'mail':
          this.mailTo(item.to)
          break
      }
    },
    navigateTo(to) {
      this.$router.push(to)
    },
    mailTo(email) {
      document.location.href = `mailto:${email}`
    },
    navigateOpen(url) {
      // document.location.href = url
      window.open(url, '_blank')
    },
  },
}
</script>

<style lang="scss">
.cursor {
  cursor: pointer;
}
.cursor:hover {
  color: red;
}
</style>
